import * as React from 'react';
import { BottomNavigation } from 'react-native-paper';
import EventInfoTab from './EventInfoTab';
import EventParticipantsTab from './EventParticipantsTab';
import EventResultsTab from './EventResultsTab';
import EventTripsTab from './EventTripsTab';
import { EVENT_STATUS } from '../../../utils/constant';

function EventTabs({ event, disabled = false }) {
  const [index, setIndex] = React.useState(0);
  const [routes] = React.useState([
    {
      key: 'info',
      title: 'Infos',
      focusedIcon: 'notebook-edit',
      unfocusedIcon: 'notebook-edit-outline',
    },
    {
      key: 'participants',
      title: 'Participants',
      focusedIcon: 'account-group',
      unfocusedIcon: 'account-group-outline',
    },
    {
      key: 'results',
      title: 'Resultats',
      focusedIcon: 'scoreboard',
      unfocusedIcon: 'scoreboard-outline',
    },
    {
      key: 'trips',
      title: 'Transports',
      focusedIcon: 'car',
      unfocusedIcon: 'car-outline',
    },
  ]);

  const renderScene = BottomNavigation.SceneMap({
    info: () => <EventInfoTab event={event} disabled={disabled} />,
    participants: () => <EventParticipantsTab event={event} disabled={disabled} />,
    results: () => <EventResultsTab event={event} disabled={EVENT_STATUS[event.status] !== EVENT_STATUS.CLOSED} />,
    trips: () => <EventTripsTab event={event} disabled={disabled} />,
  });

  return (
    <BottomNavigation
      navigationState={{ index, routes }}
      onIndexChange={setIndex}
      renderScene={renderScene}
    />
  );
}

export default EventTabs;
